import { render, staticRenderFns } from "./BeneficiosPlano.vue?vue&type=template&id=4b88b12f&scoped=true"
import script from "./BeneficiosPlano.vue?vue&type=script&lang=js"
export * from "./BeneficiosPlano.vue?vue&type=script&lang=js"
import style0 from "./BeneficiosPlano.vue?vue&type=style&index=0&id=4b88b12f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b88b12f",
  null
  
)

export default component.exports